import React from 'react'
import { connect } from 'react-redux'
import { store } from "../store"
import { push } from "react-router-redux"
import agent from '../agent'
import numberHelper from '../util/numberFormatter'
import Loading from './widgets/Loading'
import Header from './widgets/Header'
import { Link } from 'react-router-dom'
import Nav from './widgets/Nav'
import Util from '../util/util'
import ListErrors from './widgets/ListErrors'
import {
    FILE_UPLOAD_PAGE_LOADED,
    FILE_UPLOAD_PAGE_UNLOADED,
    FILE_UPLOAD
} from '../constants/actionTypes'
import _ from 'lodash'
import { Translation } from 'react-i18next'
import i18n from '../languages/lang.js'

const mapStateToProps = state => ({
    ...state.file,
    currentUser: state.common.currentUser,
    inProgress: state.common.inProgress
})

const mapDispatchToProps = dispatch => ({
    onLoad: (payload) =>
        dispatch({ type: FILE_UPLOAD_PAGE_LOADED, payload }),
    uploadFile: (payload, upload_file, directory) =>
        dispatch({ type: FILE_UPLOAD, payload, upload_file, directory }),
    onUnload: () =>
        dispatch({ type: FILE_UPLOAD_PAGE_UNLOADED }),
})

class Upload extends React.Component {
    constructor() {
        super()
        this.state = {
            upload_response_received: false,
            groups: null
        }
        this.selectUploadFile = () => ev => {
            let input = ev.target;
            if (input.files && input.files[0]) {
                this.setState({ upload_file: input.files[0] });
            }
        }
        this.upload = (upload_file) => ev => {
            ev.preventDefault()
            const directory = this.state.directory
            const groups = this.state.groups
            const payload = agent.Files.upload(upload_file, directory, groups)

            this.props.uploadFile(payload, upload_file, directory)
        }
    }
    componentWillMount() {
        if (this.props.currentUser) {
            let search = this.props.location.search
            let directory = 'root'
            if (search) {
                let args = Util.getQueryStringArgs(search.toLowerCase())
                directory = args.directory ? args.directory : 'root'
                this.setState({ directory: directory })
            }
            // let payload = agent.Files.getDirectorySimple(directory)
            const payload = Promise.all([
                agent.Files.getDirectorySimple(directory),
                agent.Files.getGroupSimpleList()
            ])
            this.props.onLoad(payload)
        } else {
            store.dispatch(push("/login"))
        }
    }
    componentWillReceiveProps(nextProps) {

    }

    componentWillUnmount() {
    }

    handleCheckboxChange(e) {
        // window.alert(e.target.checked + ' ' + e.target.value)
        let groups = this.state.groups
        let groupArr = groups ? _.split(groups, ',') : []
        if (e.target.checked) {
            groupArr.push(e.target.value)
        } else {
            groupArr = _.pull(groupArr, e.target.value)
        }
        this.setState({ groups: _.join(groupArr, ',') })
    }
    render() {
        if (!this.props.directory) {
            return (
                <Loading currentUser={this.props.currentUser} />
            )
        }
        let upload_file = this.state.upload_file
        const directory = this.props.directory
        const directory_path = Util.generateDirectoryPath(directory)
        const groups = this.props.groups || []
        return (
            <Translation>
                {
                    (t) => (
                        <div id="main">
                            <Nav selected={'files'} currentUser={this.props.currentUser} />
                            <div id="content">
                                <Header />
                                <div id="content-clear">
                                    <div className="focus-wrap">
                                        <div className='box-header'>
                                            <h2><Link to={`/files?directory=${directory.key}`}><i className="fad fa-chevron-square-left"></i></Link> {t('file.upload_title')}</h2>
                                        </div>
                                        <div className="form-item">
                                            <label>{t('file.label_directory')}</label>
                                            <span><i className="fad fa-folder"></i> {directory_path}</span>
                                        </div>
                                        <div className="form-item">
                                            <label>{t('file.label_file')}</label>
                                            <input type="file" onChange={this.selectUploadFile()} />
                                        </div>
                                        <div className="form-item">
                                            <label>{t('file.label_permissions')}</label>
                                            {
                                                groups.map(item => {
                                                    return (
                                                        <span key={item.key} className='group-name'><input type="checkbox" value={item.key} onChange={this.handleCheckboxChange.bind(this)} />{item.name}</span>
                                                    )
                                                })
                                            }
                                            <span key={'everyone-group'} className='group-name'><input className='group-name' type="checkbox" value={'all'} onChange={this.handleCheckboxChange.bind(this)} />everyone</span>
                                        </div>
                                        <div className="form-item">
                                            <button onClick={this.upload(upload_file)}>{t('file.upload_button')}</button>
                                        </div>
                                        <ListErrors errors={this.props.errors} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </Translation>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Upload)
